// extracted by mini-css-extract-plugin
export default {"container":"kudFHXdNXzEvzOHt6r03iQ==","logoContainer":"xS4ahjnkR1vKLR2GqQ4dSQ==","logo":"bvfmZ9HvhEq81xxdMGyC4w==","text":"P6E1L1r8J1bZsU2zy9KDWA=="};